import { TrashIcon } from '@heroicons/react/16/solid';
import { FC, useEffect, useState } from 'react';

import { DrillDownForm } from './DrillDownForm';
import AccordionPanel from '../Accordion/AccordionPanel';
import { Button } from '../Form/Button';
import { useDiagramStore } from '@diagram/ui/hooks/diagram-store.hook';
import { DrillDownModel } from '@diagram/model/drilldown.model';
interface DrillDownItemProps {
  drillDown: DrillDownModel;
  index: number;
}

const SidebarDrillDownItem: FC<DrillDownItemProps> = ({ drillDown, index }) => {
  const { color } = drillDown;
  const [isHovered, setIsHovered] = useState(false);
  const [name, setName] = useState(drillDown.name);
  const activeDrillDown = useDiagramStore((state) => state.activeDrilldown);
  const setActiveDrillDown = useDiagramStore(
    (state) => state.drilldown.setActiveDrilldown
  );
  const ddData = useDiagramStore((state) => state.drilldowns);
  const deleteDrillDown = useDiagramStore(
    (state) => state.drilldown.deleteDrilldown
  );

  useEffect(() => {
    if (drillDown.name) {
      setName(drillDown.name);
    } else {
      setName('Untitled DrillDown');
    }
  }, [drillDown.name, ddData]);

  const isOpen = activeDrillDown === drillDown.id;

  const handleHover = () => {
    setIsHovered((prev) => !prev);
  };

  const handleClick = () => {
    setActiveDrillDown(drillDown.id!);
  };

  const handleDelete = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    console.log('Deleting drilldown with id:', drillDown.id);
    if (drillDown.id) {
      deleteDrillDown(drillDown.id);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ')
      console.log('Div clicked via keyboard!');
  };

  return (
    <li className="w-full block">
      <div className="border border-gray-300 rounded-md shadow-xs transition-all ease-in-out duration-300 w-full">
        <div className="flex items-center gap-1">
          <div
            className="size-2 rounded-full bg-gray-300 ml-2"
            style={{ backgroundColor: color }}
          ></div>
          <div
            onMouseEnter={handleHover}
            onMouseLeave={handleHover}
            role="button"
            tabIndex={index}
            onKeyDown={handleKeyDown}
            onClick={handleClick}
            className="w-full flex justify-between rounded-lg items-center py-2 px-1.5 transition-all ease-in-out duration-300"
          >
            <p>{name}</p>
            {isHovered && (
              <Button type="button" variant="icon" onClick={handleDelete}>
                <TrashIcon className="h-4 w-4 hover:text-red-500" />
              </Button>
            )}
          </div>
        </div>
        <AccordionPanel isOpen={isOpen} overrideClasses="p-2">
          <DrillDownForm />
        </AccordionPanel>
      </div>
    </li>
  );
};

export default SidebarDrillDownItem;
